import ApplicationSerializer from './application';
import config from 'garaje/config/environment';

const ALWAYS_INCLUDED_RELATIONSHIPS = [
  'badge',
  'company',
  'config',
  'flows',
  'gdprConfiguration',
  'printer',
  'printers',
  'visualComplianceConfiguration',
];

export default class extends ApplicationSerializer {
  get alwaysIncludeLinkageData() {
    if (this._requestedDirectly) {
      return true;
    }
    return false;
  }

  set alwaysIncludeLinkageData(value) {
    // noop
  }

  shouldIncludeLinkageData(relationshipKey, _model) {
    return this._isV2 ? ALWAYS_INCLUDED_RELATIONSHIPS.includes(relationshipKey) : false;
  }

  links(location) {
    return {
      locationSubscriptions: {
        related: `${config.billingApiHost}/v2/subscriptions?filter[company_id]=${location.companyId}&filter[location_id]=${location.id}`,
      },
    };
  }

  normalize(json) {
    const { relationships } = json.data;
    if (relationships['blacklist-contacts']) {
      relationships['blocklist-contacts'] = relationships['blacklist-contacts'];
      delete relationships['blacklist-contacts'];
    }
    if (relationships['employee-screening-flow']) {
      delete relationships['employee-screening-flow'];
    }

    return json;
  }

  get _requestedDirectly() {
    return new RegExp('/a/visitors/api/v(2|3)/locations').test(this.request.url);
  }

  get _isV2() {
    return new RegExp('/a/visitors/api/v2/locations').test(this.request.url);
  }
}
